import { trpc } from '@/shared/api/trpc';

// `enabled` lets callers hold the fetch until a product is actually selected
// (the missing-coordinates quick-fix modal loads one row at a time).
export const useProductEditProduct = (
  productId: string,
  options: { enabled?: boolean } = {}
) => trpc.products.byId.useQuery({ id: productId }, options);
